import React from "react";
import { connect } from "react-redux";

class Footer extends React.Component {
  render(WrappedComponent) {
    const { isUserLogged, isMenuVisible, children, className } = this.props;

    return (
      <div
        id="footer"
        className={
          className +
          (isMenuVisible ? " menuActive" : "") +
          (isUserLogged ? "" : " noLogin")
        }
      >
        <div className="innerContainer">{children}</div>
      </div>
    );
  }
}

export default connect(state => ({
  // isUserLogged: state.client.user.isLogged,
  // isMenuVisible: state.client.view.isMenuVisible
}))(Footer);
